module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/fire-extinguisher/fire-extinguisher.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/fire-extinguisher/fire-extinguisher.png
// module id = 564
// module chunks = 0